import { api } from ".";

const feeSchedule = api.injectEndpoints({
  endpoints: (builder) => ({
    createFeeSchedule: builder.mutation<{ providerId: string; file: any }, any>(
      {
        query: ({ providerId, data, payerId }) => {
          return {
            url: `provider_procedures/import/?providerId=${providerId}&payerId=${payerId}`,
            method: "POST",
            body: data,
            formData: true,
          };
        },
      }
    ),
  }),
});

export const { useCreateFeeScheduleMutation } = feeSchedule;
